import { get, getAll } from "@bigyouth/base";

export const SELECTOR =
  'input, select, textarea, button, object, a[href], [tabindex]:not([tabindex="-1"]), area';

export const isTabbable = el => el.matches(SELECTOR);
export const getTabbable = from => get(SELECTOR, from);
export const getAllTabbable = from => getAll(SELECTOR, from);
